import { Box, Flex, HStack, Heading, Text } from '@chakra-ui/react';
import { UrlLink } from '@resistapp/client/components/links/url-link';
import { theme } from '@resistapp/client/components/shared/theme';
import { ReactNode } from 'react';

type Props = {
  title: string;
  subtitle?: ReactNode;
  labSheetUrl?: string | null;
  channelUrl?: string | null;
  control?: ReactNode;
};

export function LabPageHeader({ title, subtitle, labSheetUrl, channelUrl, control }: Props) {
  const rightItems: ReactNode[] = [];
  if (labSheetUrl) {
    rightItems.push(<UrlLink key="lab-sheet" text="Lab sheet" href={labSheetUrl} />);
  }
  if (channelUrl) {
    rightItems.push(<UrlLink key="channel" text="Slack" href={channelUrl} />);
  }
  if (control) {
    rightItems.push(
      <Box key="control" display="flex" alignItems="center">
        {control}
      </Box>,
    );
  }
  const right =
    rightItems.length > 0 ? (
      <HStack spacing={3} align="center" justify="flex-end">
        {rightItems}
      </HStack>
    ) : null;
  return (
    <Flex align="center" justify="space-between" flexWrap="wrap" gap={4} paddingBottom={theme.spacing[2]}>
      <HStack align="flex-start" spacing={3} flexWrap="wrap">
        <Heading size="lg">{title}</Heading>
      </HStack>
      {right}
      {subtitle ? (
        <Text width="100%" color="gray.600" mt={1}>
          {subtitle}
        </Text>
      ) : null}
    </Flex>
  );
}
